import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const getTimeText = (second: number) => {
    if (second < 3600) {
        return new Date(second * 1000).toISOString().substring(14, 19);
    }
    return new Date(second * 1000).toISOString().substring(11, 16);
};

export const useTimer = () => {
    const interval = useRef<NodeJS.Timeout | null>(null);
    const [initTime, setInitTime] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    useEffect(() => {
        if (currentTime === 0) {
            return;
        }
        interval.current = setTimeout(() => {
            setCurrentTime((o) => o - 1);
            if (currentTime <= 1 && interval.current) {
                clearTimeout(interval.current);
            }
        }, 1000);

        return () => {
            if (interval.current) {
                clearTimeout(interval.current);
            }
        };
    }, [currentTime]);

    const text = useMemo(() => getTimeText(currentTime), [currentTime]);

    const setCurrentTimeFn = useCallback((time: number) => {
        setInitTime(time);
        setCurrentTime(time);
    }, []);

    return {
        setCurrentTime: setCurrentTimeFn,
        second: currentTime,
        percent: initTime ? (currentTime * 100) / initTime : 0,
        text,
    };
};
